import { render } from "./SignIn.vue?vue&type=template&id=15673800&ts=true"
import script from "./SignIn.vue?vue&type=script&lang=ts"
export * from "./SignIn.vue?vue&type=script&lang=ts"

import "./SignIn.vue?vue&type=style&index=0&id=15673800&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__